// extracted by mini-css-extract-plugin
module.exports = {"config":"ListItem_config_3lFvY"};